export type SubscriptionState =
  | 'incomplete'
  | 'incomplete_expired'
  | 'trialing'
  | 'active'
  | 'past_due'
  | 'canceled'
  | 'unpaid';

export interface SubscriptionItem {
  id: number;
  subscriptionId: number;
  createdAt: string;
  updatedAt: string;
  features: string[];
  priceCode: string;
}

export interface Subscription {
  id: number;
  uuid: string;
  createdAt: string;
  updatedAt: string;
  deactivatedRequestedAt: string;
  planedDeactivatedAt: string;
  userId: number;
  couponReference: string;
  state: SubscriptionState;
  items: SubscriptionItem[];
  paymentIntentClientSecret?: string;
  nextAction?: string;
  renewsOn: string;
  paymentMethodDetails: {
    entityCode?: string;
    entityType: string;
    last4Digits: string;
  };
}

export enum RecurrenceType {
  OneOff = 'one-off',
  Fortnightly = 'fortnightly',
  Monthly = 'monthly',
}
export interface SubscriptionPrice {
  priceId: string;
  price: number;
  recurrenceType: RecurrenceType;
  recurringIn: number;
  subscriptionFeatures: Array<{ featureCode: string }>;
}

export interface SubscriptionFeature {
  featureCode: string;
}

export interface SubscriptionProduct {
  name: string;
  isCancellable: boolean;
  isPublic: boolean;
  subscriptionPrices: {
    count: number;
    prices: SubscriptionPrice[];
  };
}

export interface PaymentIntent {
  paymentIntentReference: string;
  clientSecret: string;
}
